import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/api/trainStations', request, cancelToken)
}

export {get}
